var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-32"},[_c('div',{staticClass:"welcome-text text-center mb-10 text-5xl font-bold text-primary"},[_vm._v("お問い合わせ管理へようこそ")]),_c('div',{staticClass:"flex justify-center"},[_c('img',{attrs:{"src":"logo.png","alt":""}})])])
}]

export { render, staticRenderFns }